module.exports = __webpack_public_path__ + "static/media/compprog.23f67eb5.jpg";